var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEBike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#000000;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "17.8,3.9 15.2,3.9 19.3,15.2  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 10.1,
    y1: 5.3,
    x2: 6.5,
    y2: 5.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 10.9,
    y1: 11,
    x2: 7.9,
    y2: 5.3
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "4.7,14.9 7.8,13 16.5,7.8  "
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 19.3,
    cy: 14.9,
    r: 3.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.8,13c-0.8-1.3-2.3-2-4-1.6c-1.3,0.3-2.3,1.4-2.6,2.7C1,15.3,1.3,16.4,2,17.2C2.4,17.7,3.1,18,3.7,18h3.6"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.5,18L7.5,18c0-1.1,0.9-2.1,2.1-2.1h1.6V20H9.5C8.4,20.1,7.5,19.2,7.5,18z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 13.8,
    y1: 16.5,
    x2: 11.3,
    y2: 16.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 13.8,
    y1: 19.6,
    x2: 11.3,
    y2: 19.6
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEBike);
export default __webpack_public_path__ + "static/media/e-bike.ede1bcade16f89ee9b97b262a55e1604.svg";
export { ForwardRef as ReactComponent };